/** Copyright (c) 2020 T.Rowe Price. All rights reserved. */
import { createSelector } from 'reselect';
import { getRouter } from 'state/router/RouterSelectors';

export const getTimelyAlerts = (state) => state.timelyAlerts;

export const getTimelyAlertsByPage = createSelector(
  getTimelyAlerts,
  getRouter,
  (timelyAlerts, router) => {
    const {
      location: { pathname }
    } = router;
    return timelyAlerts.filter((timelyAlert) => timelyAlert.page === pathname);
  }
);
